<template>
    <div>
        <customer-list ref="cusList" pageUrl="customer/mypage" pageType=3></customer-list>
    </div>   
</template>

<style lang="less">

</style>

<script>
import CustomerList from './Customer-list.vue'

export default {
    components: { CustomerList },

}
</script>